import Vue from 'vue'
import Router from 'vue-router'

const index = () => import('@/pages/index.vue') 
const directorIndex = () => import('@/pages/director/directorIndex.vue')
const director = () => import('@/pages/director/director.vue')
const createStudent = () => import('@/pages/createStudent.vue')
const login = () => import('@/pages/login.vue')
const frame = () => import('@/pages/frame.vue')
const plate = () => import('@/pages/plate.vue')
const cooperation = () => import('@/pages/cooperation.vue')
const classAlbum = () => import('@/pages/classAlbum.vue')
const upload = () => import('@/pages/upload.vue')
const studentFrame = () => import('@/pages/studentFrame.vue')
const studentAlbum = () => import('@/pages/studentAlbum.vue')
const directorGrowUpStep = () => import('@/pages/director/growupStep.vue')

const pictures = () => import('@/pages/pictures')
const tools = () => import('@/pages/tools')
const center = () => import('@/pages/center')
const growup = () => import('@/pages/growup')
const growupRecord = () => import('@/pages/growupRecord')
const editPlate = () => import('@/pages/editPlate')
const test = () => import('@/pages/test')
const classRecord = () => import('@/pages/classRecord.vue')
const classRecordList = () => import('@/pages/classRecordList.vue')
const classAlbumRecord = () => import('@/pages/classAlbumRecord.vue')
const studentAlbumRecord = () => import('@/pages/studentAlbumRecord.vue')
const news = () => import('@/pages/news.vue')
const mobileGrowup = () => import('@/pages/mobileGrowup.vue')
const pcGrowup = () => import('@/pages/pcGrowup.vue')
const pcGrowup2 = () => import('@/pages/pcGrowup2.vue')
const mobileEditPlate = () => import('@/pages/mobileEditPlate.vue')
const mobileGrowupBook = () => import('@/pages/mobileGrowupBook.vue')
const uploadStudent = () => import('@/pages/upload-student.vue')
const mGrowup = () => import('@/pages/mGrowup.vue')
const growupStep = () => import('@/pages/growupStep.vue')
const textTel = () => import('@/pages/text-tel.vue')
const growupTpl = () => import('@/pages/growup-tpl.vue')
const tplPages = () => import('@/pages/tpl-pages.vue')
const tplPagesPrivate = () => import('@/pages/tpl-pages-private.vue')

const directorNews = () => import('@/pages/director/news.vue')
const directorLogin = () => import('@/pages/director/directorLogin.vue')

const growupStudents = () => import('@/pages/director/growupStudents.vue')
const leaderIndex = () => import('@/pages/director/observe/index.vue')
Vue.use(Router)
const router = new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/file',
            component: () => import('@/pages/file/preview'),
            meta: {
                title: '发展阶段',
                keepAlive: false,
                tabIndex:2
            }
        },
        {
            path: '/upload/:id',
            component: upload,
            meta: {
                title: '班级相册',
                keepAlive: false,
                tabIndex:1
            }
        },
        {
            path: '/upload/:albumId/:studentId',
            component: uploadStudent,
            meta: {
                title: '学生相册',
                keepAlive: false,
                tabIndex:1
            }
        },
        {
            path: '/ai/help',
            component: () => import('@/pages/ai/help.vue'),
            meta: {
                title: 'AI助手',
                keepAlive: false,
                tabIndex:1
            }
        },
        {
            path: '/ai/aiRecord',
            component: () => import('@/pages/ai/aiRecordPage.vue'),
            meta: {
                title: 'AI助手',
                keepAlive: false,
                tabIndex:1
            }
        },
        {
            path: '/ai/:id',
            component: () => import('@/pages/ai/coze.vue'),
            meta: {
                title: 'AI助手',
                keepAlive: false,
                tabIndex:1
            }
        },
        {
            path: '/login', 
            component: login,
            meta: {
                title: '登录',
                keepAlive: false
            }
        },
        {
            path: '/director/login', 
            component: directorLogin,
            meta: {
                title: '园长登录',
                keepAlive: false
            }
        },
        {
            path: '/editPlate/:s_id/:guc_id',
            component: editPlate,
            meta: {
                title: '成长册编辑',
                keepAlive: false
            }
        },
        {
            path: '/mobileEditPlate/:s_id/:guc_id/:class_id',
            component: mobileEditPlate,
            meta: {
                title: '成长册编辑',
                keepAlive: false
            },
            children:[
                {
                    path: '/pages/:s_id/:guc_id',
                    component: () => import('../components/pages.vue'),
                    meta: {
                        title: '查看页码'
                    }
                }
            ]
        },
        {
            path: '/mobileGrowup/:s_id/:guc_id/:class_id',
            component: mobileGrowup,
            meta: {
                title: '成长册页码',
                keepAlive: true
            }
        },
        {
            path: '/mobileGrowupBook/:sid/:guc_id',
            component: mobileGrowupBook,
            meta: {
                title: '成长册预览',
                keepAlive: false,
                tabIndex:5
            }
        },
        {
            path: '/pcGrowup/:s_id/:guc_id',
            component: pcGrowup,
            meta: {
                title: '成长册页码',
                keepAlive: false
            }
        },
        {
            path: '/pcGrowup2/:s_id/:guc_id',
            component: pcGrowup2,
            meta: {
                title: '成长册页码',
                keepAlive: false
            }
        },
        {
            path: '/mGrowup',
            component: mGrowup,
            meta: {
                title: '成长册页码',
                keepAlive: false
            }
        },
        {
            path: '/tplPages/:id',
            component: tplPages,
            meta: {
                title: '模板页面',
                keepAlive: false,
                tabIndex:9
            }
        },
        {
            path: '/tplPagesPrivate/:id',
            component: tplPagesPrivate,
            meta: {
                title: '模板页面',
                keepAlive: false,
                tabIndex:9
            }
        }, 
        {
            path: '/director',
            component: directorIndex,
            redirect:'/director/index',
            meta: {
                title: '首页',
                keepAlive: true
            },
            children:[{
                path: '/director/news',
                component: news,
                meta: {
                    title: '消息中心',
                    keepAlive: false
                }
            },{
                path: '/director/index',
                component: director,
                meta: {
                    title: '首页',
                    keepAlive: false,
                    tabIndex: 1
                }
            },{
                path: '/director/observe/index',
                component: leaderIndex,
                meta: {
                    title: '观察档案',
                    keepAlive: false,
                    tabIndex: 2
                }
            },{
                path: '/director/growupStep',
                component: directorGrowUpStep,
                meta: {
                    title: '成长册',
                    keepAlive: false,
                    tabIndex: 3
                }
            },{
                path: '/director/report',
                component: () => import('@/pages/director/report/report-class.vue'),
                meta: {
                    title: '班级统计',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/report/observe',
                component: () => import('@/pages/director/report/report-class.vue'),
                meta: {
                    title: '观察档案统计',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/report-teacher',
                component: () => import('@/pages/director/report/report-teacher.vue'),
                meta: {
                    title: '教师统计',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/report-school',
                component: () => import('@/pages/director/report/report-school.vue'),
                meta: {
                    title: '园所统计',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/report-admin',
                component: () => import('@/pages/director/report/report-admin.vue'),
                meta: {
                    title: '报告管理',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/report-field',
                component: () => import('@/pages/director/report/report-field.vue'),
                meta: {
                    title: '领域统计',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/report-fieldlevel',
                component: () => import('@/pages/director/report/report-fieldlevel.vue'),
                meta: {
                    title: '观察档案统计',
                    keepAlive: false,
                    tabIndex: 4
                }
            },{
                path: '/director/observe/indexCLass',
                component: () => import('@/pages/director/observe/index-class'),
                meta: {
                    title: '观察档案',
                    keepAlive: false,
                    tabIndex: 2
                }
            },{
                path: '/director/growupStudents/:id',
                component: growupStudents,
                meta: {
                    title: '学生进度',
                    keepAlive: false,
                    tabIndex: 3
                }
            },{
                path: '/director/draft/:id',
                component: () => import('@/pages/director/observe/add'),
                meta: {
                    title: '编辑草稿',
                    keepAlive: true,
                    tabIndex:2
                }
            },
            
            {
                path: '/director/observe/addLevel',
                component: () => import('@/pages/director/observe/add-level'),
                meta: {
                    title: '发展阶段',
                    keepAlive: false,
                    tabIndex:2
                }
            },
            {
                path: '/director/observe/add',
                component: () => import('@/pages/director/observe/add'),
                meta: {
                    title: '发布观察记录',
                    keepAlive: false,
                    tabIndex:2
                }
            },
            {
                path: '/director/observe/addTask',
                component: () => import('@/pages/director/observe/add-task'),
                meta: {
                    title: '发布观察任务',
                    keepAlive: false,
                    tabIndex:2
                }
            },
            {
                path: '/director/observe/editTask',
                component: () => import('@/pages/director/observe/edit-task'),
                meta: {
                    title: '发布观察任务',
                    keepAlive: false,
                    tabIndex:2
                }
            }
            ,
            {
                path: '/director/observe/addTask/:id',
                component: () => import('@/pages/director/observe/add-task'),
                meta: {
                    title: '编辑观察任务',
                    keepAlive: false,
                    tabIndex:2
                }
            }]
        },
        {
            path: '/index',
            component: index,
            meta: {
                title: '首页',
                keepAlive: true
            },
            children:[
                {
                    path: '/createStudent',
                    component: createStudent,
                    meta: {
                        title: '建立学生',
                        keepAlive: true,
                        tabIndex:0
                    }
                },
                {
                    path: '/frame',
                    component: frame,
                    meta: {
                        title: '建立相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/news',
                    component: news,
                    meta: {
                        title: '消息中心',
                        keepAlive: false
                    }
                },
                {
                    path: '/plate',
                    component: plate,
                    meta: {
                        title: '成长册编辑',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/growupStep',
                    component: growupStep,
                    meta: {
                        title: '进度检查',
                        keepAlive: false,
                        tabIndex: 2
                    }
                },
                {
                    path: '/textTel',
                    component: textTel,
                    meta: {
                        title: '文本模板',
                        keepAlive: false,
                        tabIndex: 2
                    }
                },
                {
                    path: '/growupTpl',
                    component: growupTpl,
                    meta: {
                        title: '模板管理',
                        keepAlive: false,
                        tabIndex: 2
                    }
                },
                
                {
                    path: '/growup/:id/:guc_id',
                    component: growup,
                    meta: {
                        title: '成长册预览',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                
                {
                    path: '/growupRecord/:id/:guc_id',
                    component: growupRecord,
                    meta: {
                        title: '成长册归档',
                        keepAlive: false,
                        tabIndex:6
                    }
                },
                {
                    path: '/classRecord/:index',
                    component: classRecord,
                    meta: {
                        title: '班级归档',
                        keepAlive: false,
                        tabIndex:6
                    }
                },
                {
                    path: '/classRecordList',
                    component: classRecordList,
                    meta: {
                        title: '班级归档',
                        keepAlive: true,
                        tabIndex:6
                    }
                },
                {
                    path: '/cooperation',
                    component: cooperation,
                    meta: {
                        title: '家长协作',
                        keepAlive: true,
                        tabIndex:3
                    }
                },
                {
                    path: '/classAlbum/:id',
                    component: classAlbum,
                    meta: {
                        title: '班级相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/classAlbumRecord/:id',
                    component: classAlbumRecord,
                    meta: {
                        title: '班级相册',
                        keepAlive: false,
                        tabIndex:6
                    }
                },
                {
                    path: '/observe',
                    component: () => import('@/pages/observe/index'),
                    meta: {
                        title: '观察评测',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                
                {
                    path: '/draft',
                    component: () => import('@/pages/observe/draft'),
                    meta: {
                        title: '草稿箱',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/draft/:id',
                    component: () => import('@/pages/observe/add'),
                    meta: {
                        title: '编辑草稿',
                        keepAlive: true,
                        tabIndex:2
                    }
                },
                
                {
                    path: '/observe/addLevel',
                    component: () => import('@/pages/observe/add-level'),
                    meta: {
                        title: '发展阶段',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/observe/add',
                    component: () => import('@/pages/observe/add'),
                    meta: {
                        title: '发布观察记录',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/observe/addTask',
                    component: () => import('@/pages/observe/add-task'),
                    meta: {
                        title: '发布观察任务',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/observe/editTask',
                    component: () => import('@/pages/observe/edit-task'),
                    meta: {
                        title: '发布观察任务',
                        keepAlive: false,
                        tabIndex:2
                    }
                }
                ,
                {
                    path: '/observe/addTask/:id',
                    component: () => import('@/pages/observe/add-task'),
                    meta: {
                        title: '编辑观察任务',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/studentFrame/:id',
                    component: studentFrame,
                    meta: {
                        title: '学生相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/studentAlbum/:studentId',
                    component: studentAlbum,
                    meta: {
                        title: '学生相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/studentAlbumRecord/:studentId/:c_id',
                    component: studentAlbumRecord,
                    meta: {
                        title: '学生相册档案',
                        keepAlive: false,
                        tabIndex:6
                    }
                },
                {
                    path: '/pictures',
                    component: pictures,
                    meta: {
                        title: '个人素材',
                        keepAlive: true,
                        tabIndex: 2
                    }
                },
                {
                    path: '/tools',
                    component: tools,
                    meta: {
                        title: '常用工具',
                        keepAlive: true,
                        tabIndex:5
                    }
                },
                {
                    path: '/center',
                    component: center,
                    meta: {
                        title: '常用工具',
                        keepAlive: true,
                        tabIndex:null
                    }
                },
                {
                    path: '/test',
                    component: test,
                    meta: {
                        title: '测试工具',
                        keepAlive: true,
                        tabIndex:null
                    }
                }
                
            ]
        }
    ]
})


router.afterEach((to) => {
    document.title = to.meta.title
})
export default router